import { StrictMode } from "react"
import { createRoot, type Root } from "react-dom/client"
import {
  CommodityGraphPanel,
  type CommodityGraphSnapshot,
} from "@/components/knowledge_graph/CommodityGraphPanel"
import { EMPTY_GRAPH } from "@/lib/knowledgeGraph"

let reactRoot: Root | null = null

const EMPTY_SNAPSHOT: CommodityGraphSnapshot = {
  present: false,
  concept: null,
  graph: EMPTY_GRAPH,
  documents: [],
  related: [],
}

function unmount(): void {
  if (!reactRoot) return
  reactRoot.unmount()
  reactRoot = null
}

function mount(): void {
  const rootEl = document.getElementById("react-commodity-graph-root")
  if (!rootEl) {
    unmount()
    return
  }

  unmount()

  let snapshot = EMPTY_SNAPSHOT
  try {
    snapshot = JSON.parse(rootEl.dataset.snapshot ?? "null") as CommodityGraphSnapshot
  } catch {
    snapshot = EMPTY_SNAPSHOT
  }

  reactRoot = createRoot(rootEl)
  reactRoot.render(
    <StrictMode>
      <CommodityGraphPanel
        snapshot={snapshot ?? EMPTY_SNAPSHOT}
        commodityName={rootEl.dataset.commodityName ?? "this commodity"}
        explorerPath={rootEl.dataset.explorerPath ?? "/knowledge-explorer"}
        conceptPathPrefix={rootEl.dataset.conceptPathPrefix}
      />
    </StrictMode>
  )
}

document.addEventListener("turbo:load", mount)
document.addEventListener("turbo:before-cache", unmount)
mount()
